import { SelectionChangeResponse, Tree, TreeSearch, TreeSummary, TypeCounter } from "@rio-cloud/rio-uikit";
import { get, isEmpty } from "lodash";
import { useState } from "react";
import { IFilterOptions } from "../useAssetTree";

interface IClientTree {
  filterOptions: IFilterOptions;
  selectedClients: string[];
  setSelectedClients: (items: string[]) => void;
}

const ClientTree = ({ filterOptions, selectedClients, setSelectedClients }: IClientTree) => {
  const [searchValue, setSearchValue] = useState("");

  const formatClients =
    filterOptions?.clients.map((client) => ({
      id: client.id,
      name: client.label,
      type: "transfer",
    })) || [];

  const filteredClients = formatClients.filter((client) =>
    get(client, "name", "").toLowerCase().includes(searchValue.toLowerCase())
  );

  const handleSelectClient = ({ items }: SelectionChangeResponse) => setSelectedClients(items);

  const handleUpdateSearch = (value: string) => setSearchValue(value);

  return (
    <Tree
      items={filteredClients}
      selectedItems={selectedClients}
      onSelectionChange={handleSelectClient}
      hasMultiselect={!isEmpty(filteredClients)}
      summary={
        <TreeSummary>
          <TypeCounter icon="rioglyph rioglyph-transfer" value={filteredClients.length} />
        </TreeSummary>
      }
      search={<TreeSearch value={searchValue} placeholder="busca em cliente" onChange={handleUpdateSearch} />}
    />
  );
};

export default ClientTree;
